import type { FC } from "react";

import type { OrderItem as CartItem } from "@jti/magento";
import { useTranslations } from "@jti/ui";

import { SummaryCartItemPrice } from "../SummaryCartItemPrice";

import SummaryBundleOption from "./SummaryBundleOption";
import SummaryCartItemsTrialsBadge from "./SummaryCartItemsTrialsBadge";

import styles from "./SummaryCartItems.module.scss";

interface SummaryCartBundleItemProps extends CartItem {
  isFreeTrial: boolean;
}

const SummaryCartBundleItem: FC<SummaryCartBundleItemProps> = ({
  id,
  name,
  price: { currency, value: price },
  quantity,
  isFreeTrial,
  isGift,
  bundle_options,
}) => {
  const { __ } = useTranslations();
  const priceValue = isGift ? 0 : price;

  return (
    <li className={styles.bundleProduct} key={id} data-testid="summaryCartBundleItem">
      <div>
        <div className={styles.name}>{name}</div>
        <SummaryCartItemsTrialsBadge isFreeTrial={isFreeTrial} className={styles.trialBadge} />
      </div>

      <div className={styles.nameQuantityPrice}>
        <div className={styles.quantity}>
          {__("cart.payment_summary.qty")}: {quantity}
        </div>
        <SummaryCartItemPrice price={priceValue} currency={currency} isFreeTrial={isFreeTrial} />
      </div>

      <ol className={styles.bundleOptionsContainer}>
        {bundle_options?.map(
          ({ label, values }) =>
            values && <SummaryBundleOption categoryName={label} values={values} key={`${id}.${label}`} />
        )}
      </ol>
    </li>
  );
};

export default SummaryCartBundleItem;
